import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectionStrategy } from '@angular/core';
import { ImageType } from '../models/imageType';

export class LibSelectConfig {
  public name: string;
  public position: 'top' | 'center' | 'bottom' | 'left' | 'right' | 'unset';
  public positionPercent: string;
  public size: 'cover' | 'contain' | 'initial' | 'unset' | 'auto';
  public imagePath: string;
  public imageType: ImageType;

  constructor(imgType: ImageType, path: string, position: 'top' | 'center' | 'bottom' | 'left' | 'right' | 'unset' = 'center', percent = '', size: 'cover' | 'contain' | 'initial' | 'unset' | 'auto' = 'cover') {
    this.imageType = imgType;
    this.name = imgType.typeOfImage;
    this.imagePath = path;
    this.position = position;
    this.positionPercent = percent;
    this.size = size;
  }
}

const defaultPrePrintedImageType: ImageType = {
  typeOfImage: '',
  specialFormatting: false,
  prePrintedFormType: true,
  lastModifiedByUser: '',
  lastModifiedUser: '',
  lastModifiedDateTime: new Date(),
  createdByUser: 'SYSTEM',
  createdDateTime: new Date(),
  uid: -1,
  guid: '',
  selected: false,
  deserialize: () => { }
};

const defaultLedgerSetsImageType: ImageType = {
  typeOfImage: 'Ledger_Sets',
  specialFormatting: false,
  prePrintedFormType: false,
  lastModifiedByUser: '',
  lastModifiedUser: '',
  lastModifiedDateTime: new Date(),
  createdByUser: 'SYSTEM',
  createdDateTime: new Date(),
  uid: -1,
  guid: '',
  selected: false,
  deserialize: () => { }
};

export class GatewayLibSelects {
  static PhotosLibSelect = new LibSelectConfig(new ImageType('Photos'), './assets/lib_selection/photos.jpeg');
  static LettersLibSelect = new LibSelectConfig(new ImageType('Letters & Diaries'), './assets/lib_selection/vpr-civil-war-letter6.jpg', 'top');
  static OrdnanceReturnsLibSelect = new LibSelectConfig(new ImageType('Ordnance_Returns'), './assets/lib_selection/ordnance_rtn.jpg', 'center', '', 'initial');
  static QMSpecsLibSelect = new LibSelectConfig(new ImageType('Quartermaster_Manuals'), './assets/lib_selection/cwqm.jpg', 'unset');
  static GSOrdersLibSelect = new LibSelectConfig(new ImageType('General_Special_Orders'), './assets/lib_selection/general-special-orders.jpg');
  static MorningReportsLibSelect = new LibSelectConfig(new ImageType('Morning_Reports'), './assets/lib_selection/morning-report.jpg', 'top');
  static MusterRollsLibSelect = new LibSelectConfig(new ImageType('Muster_Rolls'), './assets/lib_selection/muster-rolls.jpg');
  static ClothingLedgerBooksLibSelect = new LibSelectConfig(new ImageType('Clothing_Ledger/Books'), './assets/lib_selection/Clothing_Thumbnail.jpg', 'center', '0%');
  static MilitaryFormsLibSelect = new LibSelectConfig(defaultPrePrintedImageType, './assets/lib_selection/Forms_Thumbnail.jpeg', 'center', '5%');
  static LedgerSetsLibSelect = new LibSelectConfig(defaultLedgerSetsImageType, './assets/lib_selection/Ledgers_Library_Photo.jpg', 'center');


  static LibSelectArray: LibSelectConfig[] = [
    GatewayLibSelects.PhotosLibSelect,
    GatewayLibSelects.LettersLibSelect,
    GatewayLibSelects.OrdnanceReturnsLibSelect,
    GatewayLibSelects.QMSpecsLibSelect,
    GatewayLibSelects.GSOrdersLibSelect,
    GatewayLibSelects.MorningReportsLibSelect,
    GatewayLibSelects.MusterRollsLibSelect,
    GatewayLibSelects.ClothingLedgerBooksLibSelect,
    GatewayLibSelects.LedgerSetsLibSelect,
    GatewayLibSelects.MilitaryFormsLibSelect
  ];
}

@Component({
  selector: 'app-lib-select-button',
  templateUrl: './lib-select-button.component.html',
  styleUrls: ['./lib-select-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LibSelectButtonComponent implements OnInit {
  @Input() config: LibSelectConfig;
  /** Override the name displayed from what is automatically populated from the `ImageType`. */
  @Input() displayName = '';
  /** Override the default 'BROWSE' text beneath the thumbnail. */
  @Input() browseText = 'BROWSE';

  @Input() selected = false;

  @Input() smallMode = false;

  @Output() clickedEmitter = new EventEmitter<ImageType>();

  cssBgPosition: 'top' | 'center' | 'bottom' | 'left' | 'right' | 'unset' = 'center';
  cssBgPosPercent = '';
  cssBgSize: 'cover' | 'contain' | 'initial' | 'unset' | 'auto' = 'auto';
  cssBgImagePath = '';
  imageType: ImageType;

  underscore = new RegExp(/_/, 'g');

  constructor() { }

  ngOnInit() {
    this.imageType = this.config.imageType;
    this.cssBgImagePath = this.config.imagePath;
    this.cssBgPosition = this.config.position;
    this.cssBgPosPercent = this.config.positionPercent;
    this.cssBgSize = this.config.size;
    if (!this.displayName) {
      this.displayName = this.imageType.typeOfImage;
    }
  }

  emitSelection(type_inp) {
    console.log("fired")
    this.clickedEmitter.emit(type_inp);
  }
}
